import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ApplFormComponent} from './appl-form/appl-form.component';
import {ApplResultComponent} from './appl-result/appl-result.component';
import {NzAlertModule} from "ng-zorro-antd/alert";
import {FormlyModule} from "@ngx-formly/core";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ApplPicsComponent} from './appl-pics/appl-pics.component';
import {NzDividerModule} from "ng-zorro-antd/divider";
import {NzCheckboxModule} from "ng-zorro-antd/checkbox";
import {NzButtonModule} from "ng-zorro-antd/button";
import {NzFormModule} from "ng-zorro-antd/form";
import {NzDescriptionsModule} from "ng-zorro-antd/descriptions";
import {NzSkeletonModule} from "ng-zorro-antd/skeleton";
import {PersonComponent} from "./person.component";
import {NzCardModule} from "ng-zorro-antd/card";
import {RouterLink} from "@angular/router";
import {InjectDataDirective} from '../@formly/directives/inject-data.directive';
import {InjectOptionsDirective} from '../@formly/directives/inject-options.directive';
import {DisabledFormDirective} from '../@formly/directives/disabled-form.directive';

@NgModule({
  declarations: [
    ApplFormComponent,
    ApplResultComponent,
    ApplPicsComponent,
  ],
  imports: [
    CommonModule,
    NzAlertModule,
    FormlyModule,
    ReactiveFormsModule,
    NzDividerModule,
    FormsModule,
    NzCheckboxModule,
    NzButtonModule,
    NzFormModule,
    NzDescriptionsModule,
    NzSkeletonModule,
    PersonComponent,
    NzCardModule,
    RouterLink,
    InjectDataDirective,
    InjectOptionsDirective,
    DisabledFormDirective
  ],
  exports: [],
  providers: []
})
export class ApplicationModule {
}
